import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';
import type { IRoute } from '..';

const DriversPage = lazy(() => import('@cobliteam/drivers/src/pages/DriverPage'));
const DriverFaceImagesPage = lazy(() => import('@cobliteam/drivers/src/pages/DriverFaceImagesPage'));

const routes: IRoute[] = [
  {
    path: Location.DRIVER_MANAGEMENT,
    team: 'squad-account-experience',
    component: DriversPage,
    exact: true,
  },
  {
    path: Location.DRIVER_MANAGEMENT_LIST,
    team: 'squad-account-experience',
    component: DriversPage,
    exact: true,
  },
  {
    path: Location.DRIVER_MANAGEMENT_NOT_IDENTIFIED,
    team: 'squad-account-experience',
    component: DriversPage,
    exact: true,
  },
  {
    path: Location.DRIVER_FACE_IMAGES,
    team: 'squad-account-experience',
    component: DriverFaceImagesPage,
    exact: true,
    hasCameraFlag: true,
  },
];

export default routes;
